import { addVisible, removeVisible } from './helper';

const CLS = '.validate--tooltip-pattern';

export function validatePattern(element: HTMLInputElement, regex: RegExp): boolean {
    if (!regex.test(element.value)) {
        addVisible(element, CLS);
        return false;
    } else {
        removeVisible(element, CLS);
        return true;
    }
}
export function liveValidatePattern(element: HTMLInputElement) {
    const pattern = element.getAttribute('pattern');
    if (!pattern) {
        return;
    }
    const p = new RegExp(pattern);
    element.addEventListener('input', (e: Event) => {
        return validatePattern(element, p);
    });
    element.addEventListener('change', (e: Event) => {
        return validatePattern(element, p);
    });
    element.addEventListener('blur', (e: Event) => {
        return validatePattern(element, p);
    });
}
